import { Component, OnInit } from '@angular/core';
import { ModalController } from '@ionic/angular';

@Component({
  selector: 'app-installation',
  templateUrl: './installation.component.html',
  styleUrls: ['./installation.component.scss'],
})
export class InstallationComponent implements OnInit {

  constructor(private modalCtrl: ModalController) { }

  ngOnInit() { }

  close(){
    this.modalCtrl.dismiss();
  }

}
